import React from 'react'
import PropTypes from 'prop-types'

import { fade, makeStyles, withStyles, Collapse, SvgIcon } from '@material-ui/core'

import TreeView from '@material-ui/lab/TreeView'
import TreeItem from '@material-ui/lab/TreeItem'

import { useSpring, animated } from 'react-spring' // web.cjs is required for IE 11 support

function MinusSquare(props) {
  return (
    <SvgIcon fontSize='inherit' style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d='M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z' />
    </SvgIcon>
  )
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize='inherit' style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d='M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z' />
    </SvgIcon>
  )
}

function TransitionComponent(props) {
  const style = useSpring({
    from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
    to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` }
  })

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  )
}

const StyledTreeItem = withStyles(theme => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3
    }
  },
  group: {
    marginLeft: 7,
    paddingLeft: 18,
    borderLeft: `1px dashed ${fade(theme.palette.text.primary, 0.4)}`
  }
}))(props => <TreeItem {...props} TransitionComponent={TransitionComponent} />)

const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1
  }
})

const ZariTreeView = ({ items, onSelect }) => {
  const classes = useStyles()
  const [selectedId, setSelectedId] = React.useState('')

  const tree = React.useMemo(() => {
    const menu = items
    const root = []
    const map = {}

    menu.forEach(node => {
      // No parentId means top level
      if (!node._parentId) return root.push(node)

      // Insert node as child of parent in flat array
      let parentIndex = map[node._parentId]
      if (typeof parentIndex !== 'number') {
        parentIndex = menu.findIndex(el => el._id === node._parentId)
        map[node.parentId] = parentIndex
      }

      if (!menu[parentIndex].childs) {
        return (menu[parentIndex].childs = [node])
      }

      menu[parentIndex].childs.push(node)
    })

    return root
  }, [items])

  const onKeyUp = (e, node) => {
    e.stopPropagation()

    const arrowsKeys = [37, 38, 39, 40]

    if (arrowsKeys.some(x => x === e.keyCode)) {
      // console.log(node)
      setSelectedId(node._id)
      onSelect(node._id)
    }
  }

  const renderTree = nodes => (
    <StyledTreeItem key={nodes._id} nodeId={nodes._id} label={nodes.title} onKeyUp={e => onKeyUp(e, nodes)}>
      {Array.isArray(nodes.childs) ? nodes.childs.map(node => renderTree(node)) : null}
    </StyledTreeItem>
  )

  return (
    <TreeView
      className={classes.root}
      defaultCollapseIcon={<MinusSquare />}
      defaultExpandIcon={<PlusSquare />}
      onNodeSelect={(e, ob) => {
        setSelectedId(ob)
        onSelect(ob)
      }}
      selected={selectedId}
    >
      {tree.map(x => {
        return renderTree(x)
      })}
    </TreeView>
  )
}

ZariTreeView.propTypes = {
  items: PropTypes.array,
  onItemClick: PropTypes.func
}

export default React.memo(ZariTreeView)
